import { useState } from "react";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);

    try {
      const res = await fetch(
        "https://www.gurukrupaeducation.com/api/login.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await res.json();

      if (data.success) {
        localStorage.setItem("user", JSON.stringify(data));

        setTimeout(() => {
          if (data.role === "admin") {
            window.location.href = "/admin/dashboard";
          } else if (data.role === "student") {
            window.location.href = "/student/dashboard";
          } else if (data.role === "teacher") {
            window.location.href = "/teacher-dashboard";
          } else if (data.role === "staff") {
            window.location.href = "/staff-dashboard";
          }
        }, 2500);
      } else {
        setLoading(false);
        alert(data.message);
      }
    } catch (error) {
      setLoading(false);
      alert("Something went wrong");
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Yatra+One&family=Poppins:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700&display=swap');

        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
        }

        :root{
          --red:#c0392b;
          --red-dark:#ff1500;
          --red-mid:#e74c3c;
          --white:#ffffff;
          --bg:#fdf8f8;
          --text:#2c0a08;
          --muted:#8b4443;
          --border:#f5c6c2;
          --red-light:#fdecea;
          --red-soft:#fadbd8;
        }

        body{
          font-family:'Nunito', sans-serif;
        }

        /* ================= LOADER ================= */

        .portal-loader{
          position:fixed;
          inset:0;
          background:
            radial-gradient(circle at top left, rgba(255,255,255,0.08), transparent 30%),
            linear-gradient(135deg, #ff1500, #c0392b);
          z-index:99999;
          display:flex;
          align-items:center;
          justify-content:center;
          flex-direction:column;
          animation:fadeIn .4s ease;
        }

        .loader-ring{
          position:absolute;
          width:220px;
          height:220px;
          border:3px solid rgba(255,255,255,0.15);
          border-top:3px solid #fff;
          border-radius:50%;
          animation:rotateRing 1.8s linear infinite;
        }

        .loader-om{
          font-family:'Yatra One', serif;
          font-size:130px;
          color:white;
          animation:omPulse 1.8s infinite ease-in-out;
          text-shadow:
            0 0 15px rgba(255,255,255,0.7),
            0 0 30px rgba(255,255,255,0.4),
            0 0 60px rgba(255,255,255,0.25);
            padding-top:90px;
        }

        .loader-text{
          margin-top:32px;
          color:white;
          font-family:'Poppins', sans-serif;
          font-size:15px;
          font-weight:700;
          letter-spacing:3px;
          animation:textBlink 1.5s infinite;
        }

        .loader-subtext{
          margin-top:10px;
          color:rgba(255,255,255,0.7);
          font-size:13px;
        }

        @keyframes rotateRing{
          100%{
            transform:rotate(360deg);
          }
        }

        @keyframes omPulse{
          0%{
            transform:scale(.92);
            opacity:.7;
          }

          50%{
            transform:scale(1.08);
            opacity:1;
          }

          100%{
            transform:scale(.92);
            opacity:.7;
          }
        }

        @keyframes textBlink{
          0%,100%{
            opacity:.4;
          }

          50%{
            opacity:1;
          }
        }

        @keyframes fadeIn{
          from{
            opacity:0;
          }

          to{
            opacity:1;
          }
        }

        /* ================= LOGIN PAGE ================= */

        .admin-login-page{
          min-height:100vh;
          background:
            radial-gradient(circle at 12% 18%, rgba(192,57,43,.16), transparent 28rem),
            radial-gradient(circle at 85% 82%, rgba(231,76,60,.14), transparent 26rem),
            var(--bg);
          display:flex;
          align-items:center;
          justify-content:center;
          padding:28px;
          overflow:hidden;
          position:relative;
        }

        .admin-login-page::before{
          content:'ॐ';
          position:absolute;
          top:50%;
          left:50%;
          transform:translate(-50%, -50%);
          font-family:'Yatra One', serif;
          font-size:min(42vw, 460px);
          color:rgba(146,43,33,.03);
          pointer-events:none;
        }

        .admin-login-shell{
          width:min(980px, 100%);
          min-height:610px;
          display:grid;
          grid-template-columns:1.05fr .95fr;
          background:white;
          border-radius:28px;
          overflow:hidden;
          box-shadow:0 26px 70px rgba(146,43,33,.16);
          position:relative;
          z-index:1;
        }

        .admin-brand-panel{
          background:
            linear-gradient(135deg, hsla(5,100%,50%,.96), rgba(192,57,43,.96));
          padding:40px;
          color:white;
          display:flex;
          flex-direction:column;
          justify-content:space-between;
          position:relative;
        }

        .admin-brand-panel::before{
          content:'ॐ';
          position:absolute;
          right:-26px;
          bottom:-42px;
          font-family:'Yatra One', serif;
          font-size:230px;
          color:rgba(255,255,255,.07);
        }

        .brand-logo{
          width:62px;
          height:62px;
          border-radius:18px;
          background:white;
          color:var(--red-dark);
          display:flex;
          flex-direction:column;
          align-items:center;
          justify-content:center;
          margin-bottom:22px;
          box-shadow:0 10px 28px rgba(0,0,0,.18);
        }

        .brand-om{
          font-family:'Yatra One', serif;
          font-size:30px;
        }

        .brand-mini{
          font-size:6.5px;
          font-weight:800;
        }

        .brand-name{
          font-family:'Poppins', sans-serif;
          font-size:2.2rem;
          line-height:1.14;
          font-weight:800;
          color:white;
        }

        .brand-tagline{
          margin-top:14px;
          color:rgba(255,255,255,.8);
          line-height:1.7;
        }

        .role-list{
          display:grid;
          gap:12px;
        }

        .role-card{
          display:flex;
          gap:12px;
          align-items:center;
          padding:14px;
          border-radius:16px;
          background:rgba(255,255,255,.12);
          border:1px solid rgba(255,255,255,.2);
          backdrop-filter:blur(12px);
        }

        .role-icon{
          width:38px;
          height:38px;
          border-radius:12px;
          background:rgba(255,255,255,.18);
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .role-title{
          font-weight:800;
          font-size:13px;
        }

        .role-text{
          font-size:11.5px;
          color:rgba(255,255,255,.7);
          margin-top:2px;
        }

        .admin-form-panel{
          padding:44px;
          background:linear-gradient(180deg, #fff 0%, #fff8f8 100%);
          display:flex;
          flex-direction:column;
          justify-content:center;
        }

        .form-kicker{
          display:inline-flex;
          align-items:center;
          gap:7px;
          width:fit-content;
          padding:6px 12px;
          border-radius:99px;
          background:var(--red-light);
          color:var(--red-dark);
          font-size:12px;
          font-weight:800;
          margin-bottom:16px;
        }

        .form-title{
          font-family:'Poppins', sans-serif;
          font-size:2.5rem;
          font-weight:800;
          color:var(--text);
          margin-bottom:8px;
        }

        .form-subtitle{
          color:var(--muted);
          line-height:1.6;
          margin-bottom:28px;
        }

        .admin-form{
          display:grid;
          gap:16px;
        }

        .field{
          display:grid;
          gap:7px;
        }

        .field label{
          font-size:13px;
          font-weight:800;
        }

        .input-wrap{
          height:50px;
          display:flex;
          align-items:center;
          gap:10px;
          border:1.5px solid var(--border);
          border-radius:14px;
          background:white;
          padding:0 14px;
        }

        .input-wrap input{
          width:100%;
          border:none;
          outline:none;
          background:transparent;
          font-size:14px;
          font-weight:700;
        }

        .form-row{
          display:flex;
          justify-content:space-between;
          align-items:center;
          margin-top:2px;
          font-size:12.5px;
        }

        .remember{
          display:flex;
          align-items:center;
          gap:7px;
        }

        .forgot-link{
          color:var(--red);
          font-weight:800;
          cursor:pointer;
        }

        .login-btn{
          height:52px;
          border:none;
          border-radius:15px;
          margin-top:10px;
          background:linear-gradient(135deg, var(--red-dark), var(--red-mid));
          color:white;
          font-family:'Poppins', sans-serif;
          font-size:15px;
          font-weight:800;
          cursor:pointer;
          transition:.2s;
        }

        .login-btn:hover{
          transform:translateY(-2px);
        }

        .secure-note{
          margin-top:20px;
          padding:13px 14px;
          border-radius:14px;
          background:var(--red-light);
          color:var(--muted);
          font-size:12.5px;
          line-height:1.5;
          font-weight:700;
          border:1px solid var(--red-soft);
        }

        @media(max-width:860px){
          .admin-login-shell{
            grid-template-columns:1fr;
          }
        }

        @media(max-width:520px){
          .admin-login-page{
            padding:14px;
          }

          .admin-brand-panel,
          .admin-form-panel{
            padding:26px;
          }

          .form-title{
            font-size:2rem;
          }

          .loader-om{
            font-size:90px;
          }

          .loader-ring{
            width:170px;
            height:170px;
          }
        }
      `}</style>

      {/* LOADER */}
      {loading && (
        <div className="portal-loader">
          <div className="loader-ring"></div>

          <div className="loader-om">ॐ</div>

          <div className="loader-text">
            AUTHENTICATING
          </div>

          <div className="loader-subtext">
            Gurukrupa Education Portal
          </div>
        </div>
      )}

      {/* LOGIN PAGE */}
      <div className="admin-login-page">
        <div className="admin-login-shell">

          {/* LEFT SIDE */}
          <section className="admin-brand-panel">

            <div>
              <div className="brand-logo">
                <div className="brand-om">ॐ</div>
                <div className="brand-mini">GURUKRUPA</div>
              </div>

              <h1 className="brand-name">
                GURUKRUPA PLACEMENT & EDUCATION SOLUTIONS
              </h1>

              <p className="brand-tagline">
                Unified portal for admins, students, teachers and staff.
              </p>
            </div>

            <div className="role-list">

              <div className="role-card">
                <div className="role-icon">🛡️</div>

                <div>
                  <div className="role-title">Admin Access</div>

                  <div className="role-text">
                    Manage users, courses, reports and platform settings.
                  </div>
                </div>
              </div>

              <div className="role-card">
                <div className="role-icon">🎓</div>

                <div>
                  <div className="role-title">Student Dashboard</div>

                  <div className="role-text">
                    Continue courses, track progress and view certificates.
                  </div>
                </div>
              </div>

              <div className="role-card">
                <div className="role-icon">👩‍🏫</div>

                <div>
                  <div className="role-title">Teacher & Staff Portal</div>

                  <div className="role-text">
                    Access academic tools, batches, learners and operations.
                  </div>
                </div>
              </div>

            </div>
          </section>

          {/* RIGHT SIDE */}
          <section className="admin-form-panel">

            <div className="form-kicker">
              🔐 Multi-Role Login
            </div>

            <h2 className="form-title">
              Welcome Back
            </h2>

            <p className="form-subtitle">
              Sign in with your registered email and password.
            </p>

            <div className="admin-form">

              <div className="field">
                <label>Email Address</label>

                <div className="input-wrap">
                  <span>✉️</span>

                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div className="field">
                <label>Password</label>

                <div className="input-wrap">
                  <span>🔑</span>

                  <input
                    type="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleLogin();
                    }}
                  />
                </div>
              </div>

              <div className="form-row">

                <label className="remember">
                  <input type="checkbox" />
                  Remember me
                </label>

                <span className="forgot-link">
                  Forgot password?
                </span>

              </div>

              <button
                className="login-btn"
                onClick={handleLogin}
              >
                Login to Portal →
              </button>

            </div>

            <div className="secure-note">
              <strong>Secure role-based access.</strong>
              {" "}Admin, student, teacher and staff users are redirected automatically.
            </div>

          </section>

        </div>
      </div>
    </>
  );
}

export default AdminLogin;